import { ElementType } from 'react';
import { Navigate, Route } from 'react-router';

function renderEmailUnverifiedRoute(routes, permissionChecker) {
  const renderComp = route => {
    if (!permissionChecker.isAuthenticated) {
      return <Navigate to='/auth/signin' />;
    }

    if (permissionChecker.isEmailVerified) {
      return <Navigate to='/' />;
    }
    const Component = route.component as ElementType;

    return <Component />;
  };

  return routes.map(route => {
    return (
      <Route key={route.path} path={route.path} element={renderComp(route)} />
    );
  });
}

export default renderEmailUnverifiedRoute;
